import { useEffect, useState } from 'react'
import { Props, TypeOfGraphs } from './typing/types'
import { graphicData } from './methods/callEndpoints'
import {
  unitStatus,
} from '../methods/statusByPercentage'
import { useFilter } from '../../../../../../hooks/filter'
import {
  Item,
  ObjectGeneric,
  onChangeEvent,
} from '../../../../../../utils/types/generals'
import { useInputs } from './hooks/inpusSelects'
import { format, startOfWeek } from 'date-fns'
import { Constants } from '../../../../../../utils/constants'
import { defaultDates } from './constants/input'
import { percentage } from '../../../../../../utils/validate/validate'
import { Box, Typography } from '@mui/material'
import { useContextState } from '../../../../../../hooks/theme'
import { useStyles } from './styles'
import { percentageColors } from '../methods/statusColors'
import { useTranslation } from 'react-i18next'
import { Query } from '../../../../../reportFolio/pages/dashboard/typing'
import { formatUnits } from './methods/formatResponse'
import { useDashboardMainContext } from '../../provider'

const useBody = (payloas: Props) => {
  const { t } = useTranslation()
  const { actionPlanData, dates, getActionPlanData, getProgrammingData, getUnitsData, currentValueExisted, getHistory, graphicHistory, unitData, setLoaders, programmingData, items, loaders, porcentage, setItems, } = useDashboardMainContext()
  const [graph, setGraph] = useState<TypeOfGraphs>('units')
  const { colors } = useContextState()
  const styles = useStyles()
  const { inputs } = useInputs({ items: items as Record<string, Item[]> })
  const [filterData, setFilterData] = useState<Record<TypeOfGraphs, ObjectGeneric>>({ actionPlan: {}, programming: {}, units: {} })
  const [dataGeneral, setDataGeneral] = useState<ObjectGeneric>({})
  const filtersU = useFilter({ formatFilter: {}, defaultValues: defaultDates })
  const filtersP = useFilter({ formatFilter: {}, defaultValues: defaultDates })
  const filtersA = useFilter({ formatFilter: {}, defaultValues: defaultDates })

  const filterByHistory = {
    units: filtersU,
    programming: filtersP,
    actionPlan: filtersA,
  }
  const [isActive, setIsActive] = useState({
    units: true,
    programming: false,
    actionPlan: false,
  })

  const options: Record<TypeOfGraphs, () => void> = {
    units: () => {
      getHistory({ name: 'units', filterByHistory, unitList: payloas?.units?.all as string[], filterData })
    },
    programming: () => {
      getHistory({ name: 'programming', filterByHistory, unitList: payloas?.units?.all as string[], filterData })
    },
    actionPlan: () => {
      getHistory({ name: 'actionPlan', filterByHistory, unitList: payloas?.units?.all as string[], filterData })
    },
  }

  const addLastPointOfTheGraphic = () => {
    let graphicCopy: {
      here?: boolean | undefined;
      name: string;
      programming?: number | string | undefined;
      noProgramming?: number | string | undefined;
      total: number | string;
      paused?: number | string | undefined;
      noStarted?: number | string | undefined;
      finished?: number | string | undefined;
      canceled?: number | string | undefined;
    }[] = []
    const graphicHistoryLegth = graphicHistory?.length

    if (!currentValueExisted[graph] && filterByHistory[graph].filterData?.intervale?.value == '1w') {
      const currentDate = format(new Date(), Constants.dateFormat)
      if (graph === 'units') {
        const programmed = unitData.programmed.amount
        const noProgrammed = unitData.notProgrammed.amount
        const total = porcentage.units
        const statusProgrammes = unitStatus(
          parseFloat(percentage({ a: programmed, b: total }))
        ).programming()
        const colorProgrammed = percentageColors[statusProgrammes]
        const statusNoProgrammes = unitStatus(
          parseFloat(percentage({ a: noProgrammed, b: total }))
        ).noProgramming()
        const colorNoProgrammed = percentageColors[statusNoProgrammes]
        const dayAdded = formatUnits({
          name: currentDate,
          colorNoProgrammed,
          colorProgrammed,
          customeLabels: {
            noProgramming: `${noProgrammed} (${percentage({ a: noProgrammed, b: total, })}%)`,
            programming: `${programmed} (${percentage({ a: programmed, b: total, })}%)`,
          },
          noProgrammed: `${t('dashboard.kpi.noProgrammed')}: ${noProgrammed} (${percentage({ a: noProgrammed, b: total, })}%)`,
          percentages: {
            programming: unitData.programmed.amount?.toString() ?? '',
            noProgramming: unitData.notProgrammed.amount?.toString() ?? '',
            total: porcentage.units?.toString() ?? '',
          },
          programmed: `${t('dashboard.kpi.programmed')}: ${programmed} (${percentage({
            a: programmed,
            b: total,
          })}%)`,
          total: `${t('dashboard.kpi.total')}: ${total}`,
          values: {
            total: total.toString()
          },
          styles
        })

        if (!!graphicHistoryLegth) {
          graphicHistory?.forEach(item => {
            if (!!item.here) {
              graphicCopy.push(dayAdded)
            } else { graphicCopy.push(item) }
          })
        } else {
          graphicCopy.push(dayAdded)
        }
        return graphicCopy
      } else if (graph === 'programming') {
        const paused = programmingData.paused.amount
        const noStarted = programmingData.noStarted.amount
        const finished = programmingData.finished.amount
        const total = porcentage.programming

        const statusProgrammes = unitStatus(
          parseFloat(percentage({ a: paused, b: total }))
        ).noProgramming()
        const colorPaused = percentageColors[statusProgrammes]
        const dayAdded = {
          name: currentDate,
          customeSettings: {
            total,
            types: {
              paused: '2',
              noStarted: '2',
              finished: '1',
            },
            remove: {
              total: true,
            },
          },
          customeData: {
            paused: (
              <Box sx={{ width: '100%' }}>
                <Typography
                  sx={{
                    color: colors.color13,
                    width: '100%',
                    lineHeight: '2',
                  }}
                >
                  {t('dashboard.kpi.total')}: {total}
                </Typography>

                <Box sx={styles.containerTitle}>
                  <Typography
                    sx={{
                      color: colors.color13,
                      width: '100%',
                    }}
                  >
                    {t('dashboard.kpi.inProgress')}:
                    {`${paused} (${percentage({
                      a: paused,
                      b: total,
                    })}%)`}
                  </Typography>

                  <Box
                    sx={styles.percentageStatus({
                      color: colorPaused.color,
                    })}
                  />
                </Box>
              </Box>
            ),
            total: <></>,
          },
          customeLabels: {
            noStarted: `${noStarted} (${percentage({
              a: noStarted,
              b: total,
            })}%)`,
            finished: `${finished} (${percentage({
              a: finished,
              b: total,
            })}%)`,
          },
          paused: paused,
          noStarted: noStarted,
          finished: finished,
          total: total,
        }

        if (!!graphicHistoryLegth) {
          graphicHistory?.forEach(item => {
            if (!!item.here) {
              graphicCopy.push(dayAdded)
            } else { graphicCopy.push(item) }
          })
        } else {
          graphicCopy.push(dayAdded)
        }
        return graphicCopy
      } else if (graph === 'actionPlan') {
        const paused = actionPlanData.paused.amount
        const noStarted = actionPlanData.noStarted.amount
        const finished = actionPlanData.finished.amount
        const canceled = actionPlanData.canceled.amount
        const total = porcentage.actionPlan

        const statusProgrammes = unitStatus(
          parseFloat(percentage({ a: paused, b: total }))
        ).noProgramming()
        const colorPaused = percentageColors[statusProgrammes]
        const dayAdded = {
          name: currentDate,
          customeSettings: {
            total,
            types: {
              paused: '2',
              noStarted: '2',
              finished: '1',
              rejected: '2',
              canceled: '2',
              expired: '2',
            },
            remove: {
              total: true,
            },
          },
          customeData: {
            paused: (
              <Box sx={{ width: '100%' }}>
                <Typography
                  sx={{
                    color: colors.color13,
                    width: '100%',
                    lineHeight: '2',
                  }}
                >
                  {t('dashboard.kpi.total')}: {total}
                </Typography>

                <Box sx={styles.containerTitle}>
                  <Typography
                    sx={{
                      color: colors.color13,
                      width: '100%',
                    }}
                  >
                    {t('dashboard.kpi.inProgress')}:
                    {`${paused} (${percentage({
                      a: paused,
                      b: total,
                    })}%)`}
                  </Typography>

                  <Box
                    sx={styles.percentageStatus({
                      color: colorPaused.color,
                    })}
                  />
                </Box>
              </Box>
            ),
            total: <></>,
          },
          customeLabels: {
            noStarted: `${noStarted} (${percentage({
              a: noStarted,
              b: total,
            })}%)`,
            finished: `${finished} (${percentage({
              a: finished,
              b: total,
            })}%)`,
            canceled: `${canceled} (${percentage({
              a: canceled,
              b: total,
            })}%)`,
          },
          paused: paused,
          noStarted: noStarted,
          finished: finished,
          canceled: canceled,
          total: total,
        }
        if (!!graphicHistoryLegth) {
          graphicHistory?.forEach(item => {
            if (!!item.here) {
              graphicCopy.push(dayAdded)
            } else { graphicCopy.push(item) }
          })
        } else {
          graphicCopy.push(dayAdded)
        }
        return graphicCopy
      }
    }
    return graphicHistory
  }

  const changeGeneralSelects = ({ target }: onChangeEvent) => {
    const { name, value } = target

    setDataGeneral((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const onChange = ({ target }: onChangeEvent, blur: any) => {
    if (!blur?.blur) {
      if (target.name == 'intervale' && target.value?.value == '1w') {
        filterByHistory[graph].onChange({
          target: {
            name: 'from',
            value: filterByHistory[graph]?.filterData?.from ? startOfWeek(new Date(filterByHistory[graph]?.filterData?.from), { weekStartsOn: 1 }) : null
          }
        })
      }

      filterByHistory[graph].onChange({ target })
    }
  }
  const changeGraph = (payload: { type: TypeOfGraphs }) => {
    if (payload.type != graph) {
      let copyActive = structuredClone(isActive)

      Object.keys(copyActive).forEach((item) => {
        copyActive = {
          ...copyActive,
          [item]: payload.type == (item as TypeOfGraphs),
        }
      })

      options[payload.type]()
      setIsActive(copyActive)
      setGraph(payload.type)
    }
  }

  const refreshCards = ({ name }: { name: TypeOfGraphs }) => {
    const refreshMethod: Record<TypeOfGraphs, () => void> = {
      units: () => { getUnitsData({ filterData, unitList: payloas?.units?.all as string[] }) },
      programming: () => { getProgrammingData({ filterData, unitList: payloas?.units?.all as string[] }) },
      actionPlan: () => { getActionPlanData({ filterData, unitList: payloas?.units?.all as string[] }) },
    }
    refreshMethod[name]()
    if (name === graph) {
      options[graph]()
    }
  }

  const getFilterData = ({ data, graph }: { data: Query; graph: TypeOfGraphs }) => {
    setFilterData(prev => ({
      ...prev,
      [graph]: data
    }))
  }

  useEffect(() => {
    if (!!filterData.actionPlan.store || !!filterData.actionPlan.divisions || !!filterData.actionPlan.zones || !!filterData.actionPlan.class) {
      if (graph === 'actionPlan') {
        options[graph]()
      }
      getActionPlanData({ filterData, unitList: payloas?.units?.all as string[] })
    }
  }, [filterData.actionPlan])
  useEffect(() => {
    if (!!filterData.units.store || !!filterData.units.divisions || !!filterData.units.zones || !!filterData.units.class) {
      if (graph === 'units') {
        options[graph]()
      }
      getUnitsData({ filterData, unitList: payloas?.units?.all as string[] })
    }
  }, [filterData.units])

  useEffect(() => {
    if (!!filterData.programming.store || !!filterData.programming.divisions || !!filterData.programming.zones || !!filterData.programming.class) {
      if (graph === 'programming') {
        options[graph]()
      }
      getProgrammingData({ filterData, unitList: payloas?.units?.all as string[] })
    }
  }, [filterData.programming])

  useEffect(() => {
    if (!!filterData.actionPlan.store || !!filterData.actionPlan.divisions || !!filterData.actionPlan.zones || !!filterData.actionPlan.class) {
      if (graph === 'actionPlan') {
        options[graph]()
      }
    }
  }, [filterData.actionPlan])
  useEffect(() => {
    if (!!payloas.units?.loading) {
      options[graph]()
    }
  }, [payloas.units?.all, filterByHistory.units.filterData, filterByHistory.programming.filterData, filterByHistory.actionPlan.filterData])

  useEffect(() => {
    setItems((prev) => ({
      ...prev,
      store: (payloas?.units?.items ?? []) as Item[],
      zones: payloas?.zoneAndClass?.zones as Item[],
      divisions: payloas?.divisions?.items as Item[],
      class: payloas?.zoneAndClass?.class as Item[],
    }))

  }, [payloas?.zoneAndClass, payloas?.divisions, payloas.units?.all])

  return {
    dates,
    loaders,
    unitData,
    porcentage,
    programmingData,
    actionPlanData,
    graph,
    isActive,
    filterByHistory,
    inputs,
    dataGeneral,
    graphicHistory,
    filterData,
    getFilterData,
    onChange,
    refreshCards,
    addLastPointOfTheGraphic,
    changeGeneralSelects,
    changeGraph,
    getUnitsData,
    getProgrammingData,
    getActionPlanData,
  }
}

export { useBody }
